import { useCallback, useEffect, useState } from "react";

const SCRIPT_ID = 'hubspot-forms-script';

export const HubSpotEmbed = () => {
  useEffect(() => {
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
  }, []);

  return null;
};

export const useHubspotEmbed = () => {
  const [initialized, setInitialized] = useState(false);

  const initForm = useCallback((portalId, formId, target) => {
    if (initialized) {
      return;
    }
    if (!target) {
      console.error('no target');
      return;
    }
    if (!window.hbspt || !window.hbspt.forms) {
      console.error('hubspot forms not initialized');
      return;
    }
    setInitialized(true);
    window.hbspt.forms.create({
      portalId,
      formId,
      target
    });
  }, [initialized]);

  return { initForm, initialized };
}